export default ({ currentUser, organizationPermissions, organizations }) => {
  if (currentUser.data.authority === 'superadmin') {
    return organizations.data.organizations.map((org) => ({ ...org, video_home_editor: true }));
  }

  const filteredOrgs = organizationPermissions.data.organization_video_permissions.filter(
    (org) => org.allow_admin_view,
  );

  return filteredOrgs?.map((org) => ({
    id: org.organization_id,
    name: org.organization_name,
    video_home_editor: org.video_home_editor,
  }));
};
